(function () {
  /* Buton etiketindeki el emojilerini temizle (👈 vb.) */
  var re = /[\u{1F446}-\u{1F450}\u{1F3FB}-\u{1F3FF}☝✊-✍️]/gu;
  function strip() {
    document.querySelectorAll('.button__label, .main-atc__label__text').forEach(function (el) {
      var t = el.textContent, n = t.replace(re, '').replace(/\s{2,}/g, ' ').replace(/\s+$/, '');
      if (n !== t) el.textContent = n;
    });
  }
  document.addEventListener('DOMContentLoaded', strip);
  window.addEventListener('load', strip);
  setTimeout(strip, 1500);
})();
